import { Select, Tooltip } from "antd"
import { useEffect, useRef, useState } from "react";
import "./PromptLibrary.scss"
import 'react-quill/dist/quill.snow.css';
import { useDispatch, useSelector } from "react-redux";
import { getPromptLibrary } from "../../apis/ChatAIAPI";
import { getPromptLibraryProcessAlly } from "../../apis/ProcessGuruAPI";
import ArrowUpIcon from "../../assets/images/icons/arrow_up.svg";


const PromptLibrary = ({ showPrompt, getPrompt, page }) => {
    const dispatch = useDispatch();
    const promptLibrary = useSelector((state) => state.prompt);
    const [showScroll, setShowScroll] = useState(false);
    const [hasScrolledPastThreshold, setHasScrolledPastThreshold] = useState(false);
    const promptRef = useRef(null);
    const [category, setCategory] = useState('');
    const [subCategory, setSubCategory] = useState('');

    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [prompts, setPrompts] = useState([]);


    useEffect(() => {

        if (promptLibrary.status === 'succeeded' && promptLibrary.prompts.length > 0) {
            const categories = promptLibrary.prompts.map(item => ({ value: item.category, label: item.category }));
            setCategory(categories[0].value)
            setCategories(categories);
            const subCategories = promptLibrary.prompts.find(item => item.category === categories[0].value).sub_category;
            setSubCategories(subCategories.map(item => ({ value: item.name, label: item.name })))
            setSubCategory(subCategories[0].name);
            getPrompts('category', categories[0].value, subCategories[0].name)
        }
    }, [promptLibrary])

    useEffect(() => {
        // if (promptLibrary.status === 'idle') {
        // }
            dispatch(getPromptLibrary(page))
       
    }, [page])


    useEffect(() => {

        const handleScroll = () => {
            const target = promptRef.current;
            if (!target) return;
            if (target.scrollTop > 100 && !hasScrolledPastThreshold) {
                setShowScroll(true);
                setHasScrolledPastThreshold(true);
            } else if (target.scrollTop <= 100) {
                setHasScrolledPastThreshold(false);
                setShowScroll(false);
            }
        }

        const target = promptRef.current;
        if (target) {
            target.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (target) {
                target.removeEventListener('scroll', handleScroll);
            }
        }

    }, [])

    const getPrompts = (type, category, subCategory) => {
        const subCategories = promptLibrary.prompts.find(item => item.category === category).sub_category;

        const prompts = subCategories.find(item => item.name === (type === "category" ? subCategories[0].name : subCategory)).prompts;
        const modifiedData = prompts.map(item => ({
            query: item.query
                .replace(/\[/g, ' <span style="color: #22a0c9; font-weight: 600; padding: 0px 3px; width: fit-content; border-radius: 3px"> ')
                .replace(/\]/g, '</span> ')
        }));
        setPrompts(modifiedData);
    }

    const handleSetCategory = (value) => {
        setCategory(value);

        const subCategories = promptLibrary.prompts.find(item => item.category === value).sub_category;

        const mapped = subCategories.map(item => ({ value: item.name, label: item.name }))

        setSubCategories([...mapped])

        if (mapped[0].value) {
            setSubCategory(mapped[0].value);
            getPrompts('category', value, mapped[0].value)
        }
    }

    const handleSetSubCategory = (value) => {
        setSubCategory(value);
        getPrompts('subCategory', category, value);
    }


    const scrollToTop = () => {
        const target = promptRef.current;
        if (target) {
            target.scrollTo({
                top: 0,
                behaviour: "smooth"
            })
        }
    }

    return (
        <div className="prompt-library" style={{display: showPrompt ? "block" : "none"}}>
            <div className="prompt-categories">
                <div className="item">
                    <div className="label">Select Category</div>
                    {categories.length > 0 && <Select className="dropdown-item" size="large" style={{ width: "100%", }} value={category} onChange={handleSetCategory} options={categories} />}
                </div>
                <div className="item">
                    <div className="label">Selecte Sub-Category</div>
                    {subCategories.length > 0 && <Select className="dropdown-item" size="large" style={{ width: "100%", }} value={subCategory} onChange={handleSetSubCategory} options={subCategories} />}
                </div>
            </div>
            <div>

            </div>
            <div className="prompt-cards" ref={promptRef}>
                {prompts.map((item, index) => (
                    <div className="prompt-card" key={index}>
                        <div className="prompt" dangerouslySetInnerHTML={{ __html: item.query }}></div>
                        <div className="try-out" onClick={() => getPrompt(item)}>Try Out</div>
                    </div>
                ))
                }
                {showScroll &&
                    <div className="scrollTop" onClick={scrollToTop}>
                        <Tooltip title="Scroll To Top"><img width={40} src={ArrowUpIcon} /></Tooltip>
                    </div>
                }
            </div>
        </div>
    )
}

export default PromptLibrary;